<template>
 <div class="">
   <b-modal id="dialog-select-service"
            ref="dialogSelectService"
            centered no-close-on-backdrop hide-footer>
    <h1>Select Shipment Service</h1>
    <div class="content__radiogroup">
      <b-form-radio-group
        v-model="selected"
        :options="optionsShipmentService"
        class="mb-3"
        value-field="value"
        text-field="text"
        name="radios-stacked"
        stacked
      ></b-form-radio-group>
    </div>
    <div class="text-center mb-3">
      <button @click="submidShipmentService()" class="button__bluecorporite">Next</button>
    </div>
  </b-modal>
 </div>
</template>
<script>
import { SHIPMENT_SERVICE } from '@/constant/shipment-details'

export default {
  props: {
    outputData: Object
  },
  data () {
    return {
      selected: SHIPMENT_SERVICE[0].value,
      optionsShipmentService: SHIPMENT_SERVICE,
      currentMode: '',
      data: {
        originArea: 'Port',
        destinationArea: 'Port',
        optiontp: 'ptp'
      }
    }
  },
  methods: {
    show (typeMode) {
      this.currentMode = typeMode.optiontp
      this.$refs.dialogSelectService.show()
    },
    submidShipmentService () {
      const typeShipment = 'type-shipment'
      const currentmode = this.outputData.serviceHead
        ? this.outputData.serviceHead : this.$route.query.mode
      this.modifyShipmentService(this.selected)
      this.emitDataToParent()
      this.$router.push({
        name: 'RequestShipment',
        params: { step: typeShipment },
        query: {
          mode: currentmode,
          ori: this.data.originArea,
          des: this.data.destinationArea
        }
      })
      this.$refs.dialogSelectService.hide()
    },
    modifyShipmentService (type) {
      this.data.optiontp = type
      if (type === 'ptp') {
        this.data.originArea = 'Port'
        this.data.destinationArea = 'Port'
        this.data.optiontp = 'ptp'
      } else if (type === 'dtp') {
        this.data.originArea = 'Door'
        this.data.destinationArea = 'Port'
        this.data.optiontp = 'dtp'
      } else if (type === 'ptd') {
        this.data.originArea = 'Port'
        this.data.destinationArea = 'Door'
        this.data.optiontp = 'ptd'
      } else if (type === 'dtd') {
        this.data.originArea = 'Door'
        this.data.destinationArea = 'Door'
        this.data.optiontp = 'dtd'
      }
    },
    emitDataToParent () {
      this.$emit('selectedService', this.data)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/global/modals/CreateShipment.vue